import { z } from 'zod';
import { ScanType, ShortCodeSchema } from './scan';
export const Modality = z.enum(['VIRTUAL', 'PRESENCIAL']);
export const AttendeeSource = z.enum([
    'CSV_IMPORT',
    'FORM',
    'MANUAL',
    'MEET_DIRECT',
    'DEMO_SEED',
    'DEMO_ACTOR',
]);
export const Attendee = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    fullName: z.string().min(1),
    email: z.string().email(),
    phone: z.string().min(1),
    qrToken: z.string().uuid(),
    shortCode: ShortCodeSchema,
    profesion: z.string().min(1).optional(),
    empresa: z.string().min(1).optional(),
    modality: Modality.optional(),
    source: AttendeeSource,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    hasAttended: z.boolean(),
    hasClaimedLunch: z.boolean(),
});
export const AttendeeImportRow = z.object({
    nombre_completo: z.string().min(1, 'Nombre obligatorio'),
    email: z.string().email('Email inválido'),
    telefono: z.string().min(1, 'Teléfono obligatorio'),
    profesion: z.string().optional(),
    empresa: z.string().optional(),
    modalidad: z.string().optional(),
});
export const AttendeeImportResult = z.object({
    total: z.number().int().nonnegative(),
    created: z.number().int().nonnegative(),
    skipped: z.number().int().nonnegative(),
    errors: z.array(z.object({
        row: z.number().int().positive(),
        reason: z.string(),
        data: z.record(z.string(), z.unknown()).optional(),
    })),
});
export const AttendeesListQuery = z.object({
    q: z.string().trim().min(1).optional(),
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(200).default(10),
    eventId: z.string().uuid().optional(),
});
export const AttendeesListResponse = z.object({
    items: z.array(Attendee),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
export const CreateAttendeeInput = z.object({
    fullName: z.string().min(1),
    email: z.string().email(),
    phone: z.string().min(1),
    profesion: z.string().min(1).optional(),
    empresa: z.string().min(1).optional(),
    eventId: z.string().uuid().optional(),
});
export const UpdateAttendeeInput = z
    .object({
    fullName: z.string().min(1),
    email: z.string().email(),
    phone: z.string().min(1),
    profesion: z.string().min(1).nullable(),
    empresa: z.string().min(1).nullable(),
})
    .partial();
export const ToggleAttendeeStatusInput = z.object({
    type: ScanType,
    enabled: z.boolean(),
});
export const CopyAttendeeToEventInput = z.object({
    eventId: z.string().uuid(),
});
export const FormIntakeInput = z.object({
    fullName: z.string().min(1),
    email: z.string().email(),
    phone: z.string().min(1),
    profesion: z.string().min(1).optional(),
    empresa: z.string().min(1).optional(),
    eventId: z.string().uuid(),
});
export const FormIntakeResponse = z.object({
    action: z.enum(['created', 'updated']),
    attendeeId: z.string().uuid(),
});
//# sourceMappingURL=attendee.js.map